@if (avatar()) {
  <img
    rmaBrokenImage
    aria-hidden="true"
    class="h-full w-full rounded-full"
    [style.background-color]="backgroundColour()"
    [src]="avatar() | rmaOptimiseImage: 'Square200'"
    [alt]=""
    [fallbackSrc]="fallbackImage() | staticImageUrl"
  />
} @else {
  <div
    aria-hidden="true"
    class="flex h-full w-full items-center justify-center rounded-full font-bold text-white"
    [style.background-color]="bg()"
  >
    {{ letter() }}
  </div>
}
